import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_LOAN: 'FETCH_LOAN',
  FETCH_LOANS: 'FETCH_LOANS',
  FETCH_ACTIVE_LOANS: 'FETCH_ACTIVE_LOANS',
  FETCH_DISPOSE_LOANS: 'FETCH_DISPOSE_LOANS',
  ACCEPT_LOAN: 'ACCEPT_LOAN',
  REJECT_LOAN: 'REJECT_LOAN',
  FETCH_LOAN_HISTORY: 'FETCH_LOAN_HISTORY',
  FETCH_EARLY_REPAYMENT: 'FETCH_EARLY_REPAYMENT',
  EARLY_REPAY_LOAN: 'EARLY_REPAY_LOAN',
  REJECT_LOANS: 'REJECT_LOANS',
  SHIFT_PAYMENT: 'SHIFT_PAYMENT',
  FETCH_LOAN_MESSAGES: 'FETCH_LOAN_MESSAGES',
  UPDATE_LOAN_PROVISION_FEE: 'UPDATE_LOAN_PROVISION_FEE',
  FETCH_LOANS_COUNT: 'FETCH_LOANS_COUNT',
  DISPOSE_LOAN: 'DISPOSE_LOAN',
  SET_EARLY_REPAYMENT: 'EARLY_REPAYMENT',
  FETCH_EARLY_REPAYMENT_RECORD: 'FETCH_EARLY_REPAYMENT_RECORD',
  SET_PENALTY_SETTING: 'SET_PENALTY_SETTING',
  RETURN_OVERPAY: 'RETURN_OVERPAY',
  SHIFT_INSTALLMENT_DATE: 'SHIFT_INSTALLMENT_DATE',
  SAVE_NOTES: 'SAVE_NOTES',
  FRAUD_CHECK: 'FRAUD_CHECK',
  CANCEL_LOAN: 'CANCEL_LOAN',
};

export default {
  fetchLoan: loanId => {
    return apiClient.get(`/loan/${loanId}`, {
      apiCallId: apiCallIds.FETCH_LOAN,
    });
  },

  fetchLoans: options => {
    return apiClient.get(`/loan?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_LOANS,
    });
  },

  fetchActiveLoans: options => {
    return apiClient.get(`/activeLoan?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ACTIVE_LOANS,
    })
  },

  fetchDisposeLoans: options => {
    return apiClient.get(`/disposeLoan?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_DISPOSE_LOANS,
    });
  },

  acceptLoan: loanId => {
    return apiClient.post(`/loan/${loanId}/accept`, null, {
      apiCallId: apiCallIds.ACCEPT_LOAN,
    });
  },

  rejectLoan: (loanId, { rejectReason }) => {
    return apiClient.post(
      `/loan/${loanId}/reject`,
      { rejectReason },
      { apiCallId: apiCallIds.REJECT_LOAN }
    );
  },

  fetchLoanHistory: options => {
    return apiClient.get(`/loanHistory?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_LOAN_HISTORY,
    });
  },

  fetchEarlyRepaymentAmount: options => {
    return apiClient.get(`/loan/earlyRepaymentAmount?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_EARLY_REPAYMENT,
    });
  },

  earlyRepayLoan: (loanId, date) => {
    return apiClient.post(`/loan/${loanId}/earlyRepayment`, { date }, {
      apiCallId: apiCallIds.EARLY_REPAY_LOAN,
    });
  },

  fetchEarlyRepaymentRecord: (loanId) => {
    return apiClient.get(`/loan/${loanId}/earlyRepayment`, {
      apiCallId: apiCallIds.FETCH_EARLY_REPAYMENT_RECORD
    })
  },

  rejectLoans: () => {
    return apiClient.put(`/loan/rejectLoans`, null, {
      apiCallId: apiCallIds.REJECT_LOANS,
    });
  },

  shiftPayment: (payload) => {
    const {
      loanId,
      data,
    } = payload;
    return apiClient.post(`/loan/${loanId}/shiftPayment`, data, {
      apiCallId: apiCallIds.SHIFT_PAYMENT,
    });
  },

  fetchLoanAllMessages: loanId => {
    return apiClient.get(`/loan/${loanId}/allMessages`, {
      apiCallId: apiCallIds.FETCH_LOAN_MESSAGES,
    });
  },

  updateLoanProvisionFee: (loanId, ProvisionFee) => {
    return apiClient.put(`/loan/${loanId}/provisionFee`, { ProvisionFee }, {
      apiCallId: apiCallIds.UPDATE_LOAN_PROVISION_FEE,
    });
  },

  disposeLoan: loanMap => {
    return apiClient.post('/loan/disposeLoan', loanMap, {
      apiCallId: apiCallIds.DISPOSE_LOAN,
    });
  },

  setEarlyRepayment: (data) => {
    return apiClient.post('loan/setEarlyRepayment', data, {
      apiCallId: apiCallIds.SET_EARLY_REPAYMENT,
    });
  },

  setPenaltySetting: (loanId, values) => {
    return apiClient.put(`/loan/${loanId}/penalty`, { values } ,{
      apiCallId: apiCallIds.SET_PENALTY_GENERATION
    });
  },

  returnOverpay: (loanId ,data) => {
    return apiClient.post(`loan/${loanId}/returnOverpay`, data, {
      apiCallId: apiCallIds.RETURN_OVERPAY
    });
  },

  shiftInstallmentDate: (loanId, date) => {
    return apiClient.put(`/loan/${loanId}/shiftInstallment`, { dateShift: date }, {
      apiCallId: apiCallIds.SHIFT_INSTALLMENT_DATE
    })
  },

  savePayrollDeductionsNotes: (loanId, notes) => {
    return apiClient.put(`/loan/${loanId}/payrollDeductionsNotes`, { notes: notes }, {
      apiCallId: apiCallIds.SAVE_NOTES
    })
  },

  fraudCheck: (loanId) => {
    return apiClient.post(`/loan/${loanId}/fraudCheck`, {
      apiCallId: apiCallIds.FRAUD_CHECK
    })
  },

  cancelLoan: loanId => {
    return apiClient.post(`/loan/${loanId}/cancel`, undefined, {
      apiCallId: apiCallIds.CANCEL_LOAN,
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/loan-management/api/index.js